import React, { useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Button, TablePagination } from "@mui/material";
import { useDebounce, useQueryParams } from "../../../hooks";
import { getAllDeletedUsers } from "./Helper";
import MuiModal from "../../../components/MuiModal";
import { deleteconsultant } from "../Consultant/Helper";

const RequestDeleteList = () => {
  const context = useOutletContext();
  const [deletedUsers, setDeletedUsers] = useState([]);
  const { getParam, setMultiParam } = useQueryParams();
  const currentPage = getParam("page");
  const currentLimit = getParam("pageSize");
  const [usersPage, setUsersPage] = useState(parseInt(currentPage) || 0);
  const [usersLimit, setUsersLimit] = useState(parseInt(currentLimit) || 10);
  const [usersTotal, setUsersTotal] = useState(0);
  const [search, setSearch] = useState('');
  const debounceSearch = useDebounce(search, 1000);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [clientInfo, setClientInfo] = useState({ id: "" });
  
  const handleChangePage = (event, newPage) => {
    fetchData(newPage, usersLimit);
    setUsersPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setUsersLimit(parseInt(event.target.value, 10));
    setUsersPage(0);
    fetchData(0, parseInt(event.target.value, 10));
  };

  const fetchData = (page, limit) => {
    getAllDeletedUsers(page + 1, limit, debounceSearch)
      .then((response) => {
        setDeletedUsers(response.data.requests.rows);
        setUsersTotal(response.data.requests.totalItems);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    context(["User Manager", "Request For Account Deletion"]);
    fetchData(usersPage, usersLimit);
  }, [debounceSearch]);

  useEffect(() => {
    setMultiParam({"page": usersPage, "pageSize": usersLimit});
  }, [usersPage, usersLimit])

  const mappedUsers = useMemo(() => {
    return deletedUsers.map((item) => ({
      id: item.id,
      ...item
    }));
  }, [deletedUsers]);

  const deleteHandler = async () => {
    const resp = await deleteconsultant(clientInfo.id);
    if (resp.status === 200) {
      setOpenDeleteModal(false);
      fetchData(usersPage, usersLimit);
    } else {
      console.error("Failed to delete user");
    }
  }

  return (
    <div className="p-5 shadow-md bg-white">
      <div className="grid grid-cols-6 gap-2">
        <h3
          className="col-span-5 text-lg uppercase tracking-wider font-bold"
          style={{ color: "#2EBAA3" }}
        >
          Request For Account Deletion
        </h3>
        <input
          type="text"
          id="search"
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search"
          className="px-3 py-1.5 mr-2 mb-2 form-control block w-full text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none"
        />
      </div>
      <br />
      <div className="overflow-x-auto relative">
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" className="py-3 px-6 uppercase">
                Sr.
              </th>
              <th scope="col" className="py-3 px-6 uppercase">
                Name
              </th>
              <th scope="col" className="py-3 px-6 uppercase">
                Email
              </th>
              <th scope="col" className="py-3 px-6 uppercase">
                Role
              </th>
              <th scope="col" className="py-3 px-6 uppercase">
                Reason
              </th>
              <th scope="col" className="py-3 px-6 uppercase">
                Requested Date
              </th>
              <th scope="col" className="py-3 px-6 uppercase">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {mappedUsers.map((user, index) => {
              return (
                <tr className="bg-white border-b" key={user.id}>
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap"
                  >
                    {index + 1}
                  </th>
                  <td className="py-4 px-6">
                    {`${user.name || ''}`}
                  </td>
                  <td className="py-4 px-6">{user.email}</td>
                  <td className="py-4 px-6">{user?.role || 'RESOURCE'}</td>
                  <td className="py-4 px-6">{user.reason}</td>
                  <td className="py-4 px-6">{user.createdAt?.split("T")[0]}</td>
                  <td className="py-4 px-6">
                          <Button
                              size="small"
                              variant="contained"
                              className="!text-xs !bg-[#3985B6] !text-white"
                              onClick={() => {
                                setOpenDeleteModal(true);
                                setClientInfo({ id: user?.user_id });
                              }}
                          >
                              Approve
                          </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <TablePagination
        component="div"
        count={usersTotal}
        page={usersPage}
        onPageChange={handleChangePage}
        rowsPerPage={usersLimit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[10]}
      />
      <MuiModal open={openDeleteModal} onCancel={() => setOpenDeleteModal(false)}>
        <div className="flex flex-col">
          <span className="text-base">Do you want to delete this user ?</span>
          <div className="flex justify-center pt-4">
            <button className={`hover:bg-red-400 bg-red-500 text-white py-2 px-4 rounded-lg mr-4`} onClick={deleteHandler}>Yes</button>
            <button className={`text-white hover:bg-green-400 py-2 px-4 rounded-lg bg-[#2ebaa3]`} onClick={() => setOpenDeleteModal(false)}>No</button>
          </div>
        </div>
      </MuiModal>
    </div>
  );
};

export default RequestDeleteList;
